declare namespace $ {

	export class $mol_icon_gift extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=gift.view.tree.d.ts.map